"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextChunkState = exports.getIsActiveChunkState = exports.getRequestedRowCount = exports.getArePageRowsIncomplete = exports.getCancelledChunkRequestProductCount = exports.getChunkRequestProductCount = exports.getNextChunkContext = exports.getNextChunkRequestVariables = exports.getShouldFetchNextChunk = exports.getCanFetchNextChunk = void 0;
const client_utils_1 = require("../../../client.utils");
const pagination_utils_1 = require("../../../../common/table-pagination/pagination.utils");
const BACKGROUND_CHUNK_CONCURRENCY = 2;
const getCanFetchNextChunk = ({ shouldChunkRows, currentChunkCount, targetPageRowCount, requestedRowCount, targetPageRequestRowCount, endCursor, isLoadingNextChunk, }) => (shouldChunkRows
    && currentChunkCount > 0
    && currentChunkCount < targetPageRowCount
    && requestedRowCount < targetPageRequestRowCount
    && !!endCursor
    && !isLoadingNextChunk);
exports.getCanFetchNextChunk = getCanFetchNextChunk;
const getShouldFetchNextChunk = ({ hasChunkLoadError, networkStatus, shouldChunkRows, currentChunkCount, targetPageRowCount, requestedRowCount, targetPageRequestRowCount, endCursor, isLoadingNextChunk, }) => !hasChunkLoadError && !(0, client_utils_1.isQueryRefetching)(networkStatus) && (0, exports.getCanFetchNextChunk)({
    shouldChunkRows,
    currentChunkCount,
    targetPageRowCount,
    requestedRowCount,
    targetPageRequestRowCount,
    endCursor,
    isLoadingNextChunk,
});
exports.getShouldFetchNextChunk = getShouldFetchNextChunk;
const getNextChunkRequestVariables = ({ firstChunkSize, requestedRowCount, pageInfo, targetPageRequestRowCount, }) => {
    if (!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor))
        return [];
    const pageStartOffset = (0, pagination_utils_1.parseOffsetFromCursor)(pageInfo.startCursor);
    const remainingRowCount = targetPageRequestRowCount - requestedRowCount;
    const requestCount = Math.min(BACKGROUND_CHUNK_CONCURRENCY, Math.ceil(remainingRowCount / firstChunkSize));
    return Array.from({ length: requestCount }, (_, index) => {
        // GraphQL `after` points to the last item before the requested window, so subtract 1 from the next window start.
        const chunkOffset = pageStartOffset + requestedRowCount + (index * firstChunkSize) - 1;
        const chunkSize = Math.min(firstChunkSize, remainingRowCount - (index * firstChunkSize));
        return {
            after: (0, pagination_utils_1.createCustomOffsetCursor)(chunkOffset),
            first: chunkSize,
        };
    });
};
exports.getNextChunkRequestVariables = getNextChunkRequestVariables;
const getNextChunkContext = ({ canFetchNextChunk, chunkState, firstChunkSize, pageInfo, requestKey, targetPageRequestRowCount, variables, }) => {
    if (!canFetchNextChunk || !requestKey || !(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor) || !variables || !chunkState)
        return undefined;
    const nextChunkRequestVariables = (0, exports.getNextChunkRequestVariables)({
        firstChunkSize,
        requestedRowCount: chunkState.requestedRowCount,
        pageInfo,
        targetPageRequestRowCount,
    });
    if (nextChunkRequestVariables.length === 0)
        return undefined;
    return {
        currentRequestKey: requestKey,
        currentChunkState: chunkState,
        nextChunkRequestVariables,
        variables,
    };
};
exports.getNextChunkContext = getNextChunkContext;
const getChunkRequestProductCount = (chunkRequestVariables) => (chunkRequestVariables.reduce((count, chunkVariables) => count + chunkVariables.first, 0));
exports.getChunkRequestProductCount = getChunkRequestProductCount;
const getCancelledChunkRequestProductCount = ({ requestedRowCount, targetPageRequestRowCount, }) => Math.max(targetPageRequestRowCount - requestedRowCount, 0);
exports.getCancelledChunkRequestProductCount = getCancelledChunkRequestProductCount;
const getArePageRowsIncomplete = ({ canFetchNextChunk, isLoadingNextChunk, chunkLoadErrorProductCount, }) => canFetchNextChunk || isLoadingNextChunk || chunkLoadErrorProductCount > 0;
exports.getArePageRowsIncomplete = getArePageRowsIncomplete;
const getRequestedRowCount = (chunkState) => { var _a; return (_a = chunkState === null || chunkState === void 0 ? void 0 : chunkState.requestedRowCount) !== null && _a !== void 0 ? _a : 0; };
exports.getRequestedRowCount = getRequestedRowCount;
const getIsActiveChunkState = ({ activeChunkState, activeRequestKey, chunkState, requestKey, }) => activeRequestKey === requestKey && activeChunkState === chunkState;
exports.getIsActiveChunkState = getIsActiveChunkState;
const getNextChunkState = (requestKey, currentChunkState, nextProductPresentations, nextChunkRequestVariables) => ({
    requestKey,
    edges: [
        ...currentChunkState.edges,
        ...nextProductPresentations.flatMap(({ edges }) => edges),
    ],
    pageInfo: nextProductPresentations[nextProductPresentations.length - 1].pageInfo,
    requestedRowCount: currentChunkState.requestedRowCount + (0, exports.getChunkRequestProductCount)(nextChunkRequestVariables),
});
exports.getNextChunkState = getNextChunkState;
